const initialState = {
  status: "idle", // idle | loading | ready | error
  user: null,
  company: null,
  profile: null,
  profiles: [],
  applications: [],
  permissions: [],
  error: null,
  resolvedAt: null,
};

const authzReducer = (state = initialState, action) => {
  switch (action.type) {
    case "AUTHZ_LOADING":
      return { ...state, status: "loading", error: null };
    case "AUTHZ_SUCCESS": {
      const payload = action.payload || {};
      return {
        ...state,
        status: "ready",
        user: payload.user || null,
        company: payload.company || null,
        profile: payload.profile || null,
        profiles: Array.isArray(payload.profiles) ? payload.profiles : [],
        applications: payload.applications || [],
        permissions: payload.permissions || [],
        resolvedAt: payload.resolvedAt || new Date().toISOString(),
        error: null,
      };
    }
    case "AUTHZ_FAILURE":
      return {
        ...state,
        status: "error",
        error: action.payload || "Failed to load authorization",
        permissions: [],
        applications: [],
        profiles: [],
      };
    case "AUTHZ_CLEAR":
      return { ...initialState };
    case "USER_LOGOUT":
      return { ...initialState };
    default:
      return state;
  }
};

export default authzReducer;
